import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Input,
  Renderer2,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { AccountService, SyncState } from "@root/router/channel/account/account.service";
import { RelationService, HouseType, AirbnbLinkType } from "../relation.service";
import { CreateHouseComponent } from "@root/router/component/property/create-house/create-house.component";
import { CreateHouseTypeComponent } from "@root/router/component/property/create-house-type/create-house-type.component";

import _ from "lodash";
import { Observable, Subject, filter, fromEvent, mergeMap, of } from "rxjs";
import { MemberService } from "@root/router/index/member.service";
import { TranslateService } from "@root/shared/service/translate.service";
import TWEEN from "@tweenjs/tween.js";
import { HouseRelationRightPanelComponent } from "../house-relation-right-panel/house-relation-right-panel.component";
import { HouseRelationLeftPanelComponent } from "../house-relation-left-panel/house-relation-left-panel.component";
import { HttpClient } from "@angular/common/http";

interface Coords {
  x: number;
  y: number;
}

export interface HostexModel {
  id: number;
  title: string;
  type: "house" | "house_type";
  card: HouseModel[];
}
export class HouseModel {
  // id: number;
  account_id?: number;
  link_id?: number; // 关联过的房源才有
  origin_house_id: string;
  thumbnail: string;
  title: string;
  thirdparty: number;
  inventory: number;
  previewUrl: string;
  linkUrl: string;
  username: string;
  constructor(option) {
    _.forOwn(option, (value, key) => (this[key] = value));
  }
}

@Component({
  selector: "host-base-house-relation",
  templateUrl: "./base-house-relation.component.html",
  styleUrls: ["./base-house-relation.component.scss"],
})
export class BaseHouseRelationComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("leftCMP") leftCMP: HouseRelationLeftPanelComponent;
  @ViewChild("rightCMP") rightCMP: HouseRelationRightPanelComponent;
  @Output() onTypeTabChange = new EventEmitter();
  @Output() onUnlinkHouse = new EventEmitter();
  @Output() onLinkHouse = new EventEmitter();
  leftLoading = false;
  rightLoading = false;

  destroy$ = new Subject();
  constructor(
    private modal: NzModalService,
    private msg: NzMessageService,
    private relationSrv: RelationService,
    private accountService: AccountService,
    private member: MemberService,
    private t: TranslateService,
    private renderer: Renderer2,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    // this.fetchHouseList();
    // this.fetchHostexHouseList();
    // this.fetchHostexHouseTypeList();
  }

  ngAfterViewInit() {
    // fromEvent(window, "beforeunload")
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((e: any) => {
    //     var e = window.event || e;
    //     // e.returnValue = "确定离开当前页面吗？";
    //     e.returnValue = this.translate.syncGet("warning.confirm_leave");
    //   });
  }

  private requestUnlink(params: { property_id?: number; room_type_id?: number; link_id: number }) {
    return this.http.post("/api/listing_linking/unlink", params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("channel-house_relation-base_house_relation_ts_已解除关联"));
      }
    });
  }

  private requestLink(params: {
    property_id?: number;
    room_type_id?: number;
    thirdparty_account_id: number;
    origin_house_id: string;
  }) {
    return this.http.post("/api/listing_linking/link", params);
  }

  private requestLinkCheck(params: {
    property_id?: number;
    room_type_id?: number;
    thirdparty_account_id: number;
    origin_house_id: string;
  }) {
    return this.http.get("/api/listing_linking/check", { params });
  }

  private displayCreateHouseTypeModal() {
    const modal = this.modal.create({
      // nzTitle: "创建房型",
      nzTitle: this.t.t("house.create_house_type"),
      nzContent: CreateHouseTypeComponent,
      nzFooter: null,
      nzWidth: 450,
      // nzComponentParams: {
      //   displaySuccessAlert: false,
      // },
    });
    modal.afterClose.subscribe((res) => {
      this.msg.success(
        this.t.syncGet("success.house_relation.house_type_created"),
        // '房型已创建，正在保存数据并刷新页面'
      );
    });
  }

  private displayCreateHouseModal() {
    if (this.member.isEditionExceedQuantityLimit()) {
      this.member.editionCreateHouseLimitWarning();
      return;
    }

    const modal = this.modal.create({
      // nzTitle: "创建房间",
      nzTitle: this.t.syncGet("house.create_house"),
      nzContent: CreateHouseComponent,
      nzFooter: null,
      // nzComponentParams: {
      //   displaySuccessAlert: false,
      // },
    });
    modal.afterClose.subscribe(() => {
      this.msg.success(
        this.t.syncGet("success.house_relation.house_created"),
        // '房间已创建，正在保存数据并刷新页面'
      );

      this.member.requestEditionInfo();
      // this.fetchHostexHouseList();
      // this.fetchHouseList();
    });
  }

  private displayResvMigrateWarning() {
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        nzTitle: this.t.t("channel_house-relation-migrate-title"),
        nzContent: this.t.t("channel_house-relation-migrate-title"),
        nzWidth: 545,
        nzOkText: this.t.t("channel_house-relation-migrate-confirm-btn"),
        nzCancelText: this.t.t("word.no"),
        nzOnOk: () => {
          observer.next(true);
        },
        nzOnCancel: () => {
          observer.next(false);
        },
      });
      modal.afterClose.subscribe(() => {
        observer.complete();
      });
    });
  }

  private checkIfNeedMigrateResv(data: { from: HouseModel; to: HostexModel }) {
    return new Observable((observer) => {
      const { from, to } = data;
      const params = {
        thirdparty_account_id: from.account_id,
        origin_house_id: from.origin_house_id,
      };
      if (to.type === "house") {
        Object.assign(params, { property_id: to.id });
      } else {
        Object.assign(params, { room_type_id: to.id });
      }
      this.requestLinkCheck(params).subscribe((rst: any) => {
        observer.next(rst?.data?.ask_for_migration);
        observer.complete();
      });
    }).pipe(
      mergeMap((value) => {
        if (value) {
          return this.displayResvMigrateWarning();
        }

        return of(false);
      }),
    );
  }

  private getStyleAsText(cssObj): string {
    return Object.keys(cssObj)
      .map((key) => `${key}: ${typeof cssObj[key] === "number" ? cssObj[key] + "px" : cssObj[key]}`)
      .join(";");
  }

  private setNodeStyle(node, style) {
    this.renderer.setStyle(node, "cssText", this.getStyleAsText(style));
  }

  private startMoveAnimate(
    sourceCoords: Coords,
    destCoords: Coords,
    duration: number,
    onUpdate: (coords: Coords) => void,
    onComplete: () => void,
  ) {
    function animate(time) {
      requestAnimationFrame(animate);
      TWEEN.update(time);
    }
    requestAnimationFrame(animate);

    new TWEEN.Tween(sourceCoords)
      .to(destCoords, duration)
      .easing(TWEEN.Easing.Cubic.InOut)
      .onUpdate(() => {
        onUpdate(sourceCoords);
      })
      .onComplete(() => {
        onComplete();
      })
      .start();
  }

  onUnlink(payload) {
    this.onUnlinkHouse.emit();
    console.log("right cmp: ", this.rightCMP, " payload: ", payload);

    this.relationSrv.activeChannelTab(0);

    const sourceNode = payload.node as Element;
    const sourcePosition = sourceNode.getBoundingClientRect();

    const destPosition = this.rightCMP.listContainer?.nativeElement?.getBoundingClientRect();

    const cloned = sourceNode.cloneNode(true) as Element;
    const style = {
      position: "fixed",
      left: sourcePosition.left,
      top: sourcePosition.top,
      width: sourcePosition.width,
      background: "#fff",
    };
    this.setNodeStyle(cloned, style);

    document.body.appendChild(cloned);

    this.startMoveAnimate(
      { x: sourcePosition.x, y: sourcePosition.y },
      { x: destPosition.x, y: destPosition.y },
      300,
      (coords) => {
        this.setNodeStyle(cloned, { ...style, left: coords.x, top: coords.y });
      },
      () => {
        this.renderer.removeChild(cloned.parentNode, cloned);

        //TODO: 应该有回退机制。请求失败后，撤回操作
        const { from, house } = payload.data;
        /** 前端操作，从左边删除，在右边添加。从from里删除house，将house添加到右侧 */
        this.relationSrv.addCardToHouses(house, from);
        this.relationSrv.removeCardFromHostex(house, from);
        /** 执行请求unlink，真正的将数据保存 */
        const params = {
          link_id: house.link_id,
        };
        if (from.type === "house") {
          Object.assign(params, { property_id: from.id });
        } else {
          Object.assign(params, { room_type_id: from.id });
        }
        this.requestUnlink(params);
      },
    );
  }

  onLink(payload: { node: Node; data: { from: HouseModel; to: HostexModel } }) {
    this.onLinkHouse.emit();

    this.checkIfNeedMigrateResv(payload.data).subscribe((needMigrate) => {
      console.log("need migrate:", needMigrate);

      const leftPanelContainer = this.leftCMP.scrollContainer.nativeElement;

      const sourceNode = payload.node as Element;
      const sourcePosition = sourceNode.getBoundingClientRect();

      const destNode = leftPanelContainer.querySelector(".hostex-card.selected .link-btn") as Element;
      const destPosition = destNode.getBoundingClientRect();

      const cloned = sourceNode.cloneNode(true) as Element;
      const style = {
        position: "fixed",
        left: sourcePosition.left,
        top: sourcePosition.top,
        width: sourcePosition.width,
        background: "#fff",
      };
      this.setNodeStyle(cloned, style);
      document.body.appendChild(cloned);

      this.startMoveAnimate(
        { x: sourcePosition.x, y: sourcePosition.y },
        { x: destPosition.x, y: destPosition.y },
        300,
        (coords) => {
          this.setNodeStyle(cloned, { ...style, left: coords.x, top: coords.y });
        },
        () => {
          this.renderer.removeChild(cloned.parentNode, cloned);
          // console.log("onLink: ", payload);
          const { from, to } = payload.data;

          /** 执行请求unlink，真正的将数据保存 */
          const params = {
            thirdparty_account_id: from.account_id,
            origin_house_id: from.origin_house_id,
            migrate_reservations: needMigrate,
          };
          if (to.type === "house") {
            Object.assign(params, { property_id: to.id });
          } else {
            Object.assign(params, { room_type_id: to.id });
          }
          this.requestLink(params).subscribe((rst: any) => {
            if (rst.error_code === 0) {
              /** 前端操作，从右边列表删除，在左边列表添加。将from添加到to里 */
              this.relationSrv.addCardToHostex(from, to);
              this.relationSrv.removeCardFromHouses(from, to);
              this.msg.success(this.t.t("channel-house_relation-base_house_relation_ts_已关联"));
              from.link_id = rst.data.link_id; // 房间关联后会多一个link_id。这里手动更新link_id，避免每次刷新接口

              console.log("from: ", from);
            }
          });
        },
      );
    });
  }

  /** @deprecated */
  onCreate(type) {
    if (type === HouseType.Multi) {
      this.displayCreateHouseTypeModal();
    } else {
      this.displayCreateHouseModal();
    }
  }

  onSave() {}

  // onRemove(data) {
  //   console.log("data:", data);
  //   const { type, id } = data;
  //   this.modal.confirm({
  //     nzTitle: this.t.syncGet(
  //       type === HouseType.Single ? "warning.confirm_remove_house" : "warning.confirm_remove_house_type"
  //     ),
  //     nzOnOk: () => {
  //       if (type === HouseType.Single) {
  //         this.requestRemoveHostexHouse(id);
  //       } else {
  //         this.requestRemoveHostexHouseType(id);
  //       }
  //     },
  //   });
  // }

  onSync() {
    this.accountService.syncAllHouses();
  }

  onRefresh(data) {
    console.log("refresh data: ", data);
    const house = data.house;
    if (data.type === HouseType.Single) {
      this.http.post("/api/house/read_thirdparty_house", { house_id: house.house_id }).subscribe();
    } else {
      this.http.post("/api/house_type/read_thirdparty_house", { house_type_id: house.house_type_id }).subscribe();
    }
  }

  onRefreshChannelHouses(thirdparty_type) {
    this.http.post("/api/thirdparty/syncer_house", { thirdparty_type, from: "refresh" }).subscribe((res) => {});

    // this.syncService.refreshThirdpartyHouseOfChannel(data);
  }

  // canDeactivate() {
  //   if (this.isModify) {
  //     // 您刚刚修改了房间关联但还未保存，如果现在离开将丢失刚才的操作，是否现在离开？
  //     const confirmText = this.t.syncGet("warning.relation_not_saved");
  //     return confirm(confirmText);
  //   }
  //   return true;
  // }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
